import { create } from "zustand";

const START_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";

export interface BoardArrow {
  from: string;
  to: string;
  color?: string;
}

export interface BoardHighlight {
  square: string;
  color?: string;
}

interface BoardState {
  fen: string;
  orientation: "white" | "black";
  arrows: BoardArrow[];
  highlights: BoardHighlight[];
  /** Which of the player's own analyzed games the current position belongs to, if any (see parse-board-markers.ts's [GAME: ...] marker) — drives whether MoveNavigator renders and which game's moves it fetches. Null when the board is showing a position not tied to a specific analyzed game. */
  activeGameId: string | null;
  /** Sets a new position, clearing any arrows/highlights from the previous position (they're position-specific annotations, not persistent decorations). Orientation defaults to "white" when omitted so unrelated FENs (no orientation info) don't inherit a stale flip from a previous game. gameId defaults to null for the same reason — a plain FEN with no [GAME: ...] marker means "this isn't tied to a specific analyzed game," not "keep whatever game was active before." */
  setPosition: (fen: string, orientation?: "white" | "black", gameId?: string | null) => void;
  setAnnotations: (arrows: BoardArrow[], highlights: BoardHighlight[]) => void;
}

export const useBoardStore = create<BoardState>((set) => ({
  fen: START_FEN,
  orientation: "white",
  arrows: [],
  highlights: [],
  activeGameId: null,
  setPosition: (fen, orientation = "white", gameId = null) =>
    set({ fen, orientation, activeGameId: gameId, arrows: [], highlights: [] }),
  setAnnotations: (arrows, highlights) => set({ arrows, highlights }),
}));
